/**
 * Tiny deterministic hash — string → unsigned int. Good enough for picking
 * a variant + offsetting a focal rotation, and for the decoder's HITL
 * dedupe nonce. NOT cryptographic.
 */
export function seedHash(seed: string | number | undefined): number {
  if (seed === undefined) return 0
  const s = String(seed)
  let h = 2166136261 >>> 0
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i)
    h = Math.imul(h, 16777619) >>> 0
  }
  return h
}
